import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { styled, keyframes, css } from 'styled-components';
const loading = keyframes `
  0%, 100% {transform: scale(0)}
  50% {transform: scale(1.0)}
`;
const Circle = styled.div `
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.main};
  border-radius: 100%;
  opacity: 0.6;
  top: 0;
  left: 0;
  animation-fill-mode: both;
  transform: scale(0);
  ${({ $index }) => $index &&
    css `
      animation: ${loading} 2s ${$index}s infinite ease-in-out;
    `}
`;
const Container = styled.div `
  width: 10%;
  height: auto;
  max-width: 40px;
  min-width: 15px;
  position: relative;
  &:before {
    content: '';
    padding-top: 100%;
    display: block;
  }
`;
const Wrapper = styled.div `
  padding: ${({ type }) => (type === 'contain' ? '15px' : '2%')} 0;
  height: ${({ type }) => (type === 'contain' ? 'auto' : '100%')};
  width: 100%;
  position: ${({ type }) => (type === 'form-loader' ? 'absolute' : 'relative')};
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${({ type }) => type === 'form-loader' &&
    css `
      background-color: rgba(255, 255, 255, 0.3);
      top: 0;
      left: 0;
    `}
  ${({ type }) => type === 'initial' &&
    css `
      flex: auto;
    `}
`;
const Loader = ({ type }) => (_jsx(Wrapper, { type: type, "data-testid": 'loader-circle', children: _jsxs(Container, { children: [_jsx(Circle, { $index: '0' }), _jsx(Circle, { $index: '1' })] }) }));
export default React.memo(Loader);
